module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "handins"
  }, [_c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.handIns) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.handIns), function(handIn) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('h3', [_vm._v(_vm._s(handIn.user.firstName) + " " + _vm._s(handIn.user.lastName))]), _vm._v(" "), _c('h4', {
      style: ({
        'color': _vm.assessmentColor(handIn.assessment)
      })
    }, [_vm._v(_vm._s(_vm.getAssessment(handIn.assessment)))]), _vm._v(" "), _c('h5', [_vm._v("Submitted on " + _vm._s(_vm._f("longDate")(handIn.createdAt)))]), _vm._v(" "), _c('blockquote', [_vm._v(_vm._s(handIn.comments))]), _vm._v(" "), (handIn.url && handIn.url.length > 0) ? _c('div', _vm._l((handIn.url), function(url) {
      return _c('a', {
        staticClass: "btn btn-default",
        attrs: {
          "href": url,
          "target": "_blank"
        }
      }, [_vm._v("Download File")])
    })) : _vm._e()])
  })) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Hand-Ins")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ebe4176!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HandIns.vue
// module id = 2028
// module chunks = 2